import * as Config from '../config';

import useGetFromApiSearch from './useGetFromApiSearch';

const useArtists = (id, pathApi, isBaseRootApi = true, perPage = 100) => {
  const [response] = useGetFromApiSearch(id, pathApi, isBaseRootApi, `artists`, perPage);
  let result = (response) ? { ...response } : null;

  if (response) {
    result.items = (response.items) ? response.items.map( isBaseRootApi ? Config.formattedArtist : Config.formattedArtistSearchV1) : null;
  }

  return [result];
};

export default useArtists;
